import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import CloseButton from './CloseButton.Container';

const Bar = styled.div`
	align-items: center;
	background-color: ${(props) => props.theme.colors.lightRed};
	border-bottom: ${(props) => props.theme.borderWidth.bar} solid
		${(props) => props.theme.colors.darkRed};
	border-bottom-right-radius: 9999px;
	border-right: ${(props) => props.theme.borderWidth.bar} solid
		${(props) => props.theme.colors.darkRed};
	border-top-right-radius: 9999px;
	border-top: ${(props) => props.theme.borderWidth.bar} solid
		${(props) => props.theme.colors.darkRed};
	box-shadow: ${(props) => props.theme.shadow.bar};
	color: ${(props) => props.theme.colors.white};
	display: flex;
	flex-wrap: nowrap;
	font: ${(props) => props.theme.font.default};
	font-size: 4.2vmin;
	left: -3vmin;
	padding: 2.4vmin;
	position: absolute;
	top: 1vh;
`;

const Text = styled.span`
	margin-left: 5.2vmin;
	margin-right: 5.2vmin;
	font-weight: bold;
`;

export interface Props {
	onSkip: () => void;
}

const TutorialBarLayer: FunctionComponent<Props> = (props: Props) => {
	const { onSkip } = props;

	return (
		<Bar>
			<Text>
				<Trans>tutorial</Trans>
			</Text>
			<CloseButton small onClick={onSkip} />
		</Bar>
	);
};

export default TutorialBarLayer;
